import React from 'react';
import AuthContextProvider from './components/AuthContextProvider';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './routes';

const App: React.FC = () => {
  return (
    <Router>
      <AuthContextProvider>
        <Routes />
      </AuthContextProvider>
    </Router>
  );
};

export default App;
